var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6094 0.589817C31.349 0.589817 40.0504 9.29126 40.0504 20.0309C40.0504 30.7705 31.349 39.4719 20.6094 39.4719C9.86975 39.4719 1.16831 30.7705 1.16831 20.0309C1.16831 9.29126 9.86975 0.589817 20.6094 0.589817ZM20.6094 35.7092C29.2324 35.7092 36.2877 28.7323 36.2877 20.0309C36.2877 11.4078 29.2324 4.3526 20.6094 4.3526C11.9079 4.3526 4.9311 11.4078 4.9311 20.0309C4.9311 28.7323 11.9079 35.7092 20.6094 35.7092ZM25.3913 27.5565L18.728 22.6962C18.4928 22.5394 18.4144 22.2258 18.4144 21.9907V9.05609C18.4144 8.58574 18.8064 8.11539 19.3551 8.11539H21.8636C22.334 8.11539 22.8043 8.58574 22.8043 9.05609V20.1877L27.9782 24.0288C28.4485 24.3424 28.5269 24.8911 28.2133 25.3615L26.7239 27.3213C26.4103 27.7916 25.8616 27.87 25.3913 27.5565Z",
    fill: "#183864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.99dfa2baeb1f5969869dcd2208c0eacb.svg";
export { ForwardRef as ReactComponent };